export default "__VITE_ASSET__Bi5zkk8q__"